import React, { useState } from 'react';
import { useStudioStore } from '../../stores/useStudioStore';
import { GARMENT_PROMPTS } from '../../constants/garmentPrompts';

export const PanelConfig: React.FC = () => {
  const { 
    openaiKey, setOpenaiKey, 
    replicateKey, setReplicateKey,
    prompt, setPrompt,
    garmentType, setGarmentType,
    quality, setQuality,
    size, setSize
  } = useStudioStore();

  const handleGarmentChange = (g: string) => {
    setGarmentType(g);
    if (GARMENT_PROMPTS[g]) {
      setPrompt(GARMENT_PROMPTS[g]);
    }
  };

  const [showOai, setShowOai] = useState(false);
  const [showRep, setShowRep] = useState(false);

  return (
    <div className="panel" id="panelA">
      <div className="panel-scroll">

        <div className="section">
          <div className="section-label">API key — OpenAI</div>
          <div className="key-wrap">
            <input 
              type={showOai ? 'text' : 'password'} 
              value={openaiKey}
              onChange={e => setOpenaiKey(e.target.value)}
              placeholder="sk-… (optional override)" 
              autoComplete="off" 
            />
            <button className="key-toggle" onClick={() => setShowOai(!showOai)}>
              {showOai ? 'hide' : 'show'}
            </button>
          </div>
          <div className="key-status">
            <div className={`dot ${openaiKey ? 'valid' : 'invalid'}`}></div>
            <span style={{ fontSize: '11px', color: 'var(--text3)' }}>Enter your OpenAI API key</span>
          </div>
        </div>

        <div className="section">
          <div className="section-label">API key — Replicate</div>
          <div className="key-wrap">
            <input 
              type={showRep ? 'text' : 'password'} 
              value={replicateKey}
              onChange={e => setReplicateKey(e.target.value)}
              placeholder="r8_… (optional override)" 
              autoComplete="off" 
            />
            <button className="key-toggle" onClick={() => setShowRep(!showRep)}>
              {showRep ? 'hide' : 'show'}
            </button>
          </div>
          <div className="key-status">
            <div className={`dot ${replicateKey ? 'valid' : 'invalid'}`}></div>
            <span style={{ fontSize: '11px', color: 'var(--text3)' }}>Used for 4× upscaling after approval</span>
          </div>
        </div>

        <div className="section">
          <div className="section-label">Garment type</div>
          <div className="garment-tabs">
            <button 
              className={`g-btn ${garmentType === 'top' ? 'sel' : ''}`}
              onClick={() => handleGarmentChange('top')}
            >
              Top
            </button>
            <button 
              className={`g-btn ${garmentType === 'bottom' ? 'sel' : ''}`}
              onClick={() => handleGarmentChange('bottom')}
            >
              Bottom
            </button>
            <button 
              className={`g-btn ${garmentType === 'dress' ? 'sel' : ''}`}
              onClick={() => handleGarmentChange('dress')}
            >
              Dress
            </button>
          </div>
        </div>

        <div className="section">
          <div className="section-label">Prompt</div>
          <textarea 
            value={prompt}
            onChange={e => setPrompt(e.target.value)}
            maxLength={32000} 
            placeholder="Describe the fashion scene..."
          />
          <div className="char-count">{prompt.length} / 32000</div>
        </div>

        <div className="section">
          <div className="section-label">Quality</div>
          <div className="quality-grid">
            <button className={`q-btn ${quality === 'low' ? 'sel' : ''}`} onClick={() => setQuality('low')}>
              <span className="q-name">Low</span><span className="q-desc">Fast</span>
            </button>
            <button className={`q-btn ${quality === 'medium' ? 'sel' : ''}`} onClick={() => setQuality('medium')}>
              <span className="q-name">Medium</span><span className="q-desc">Balanced</span>
            </button>
            <button className={`q-btn ${quality === 'high' ? 'sel' : ''}`} onClick={() => setQuality('high')}>
              <span className="q-name">High</span><span className="q-desc">Best</span>
            </button>
          </div>
        </div>

        <div className="section">
          <div className="section-label">Output size</div>
          <div className="size-tabs">
            <button className={`s-btn ${size === '1024x1024' ? 'sel' : ''}`} onClick={() => setSize('1024x1024')}>1024×1024</button>
            <button className={`s-btn ${size === '1536x1024' ? 'sel' : ''}`} onClick={() => setSize('1536x1024')}>1536×1024</button>
            <button className={`s-btn ${size === '1024x1536' ? 'sel' : ''}`} onClick={() => setSize('1024x1536')}>1024×1536</button>
            <button className={`s-btn ${size === 'auto' ? 'sel' : ''}`} onClick={() => setSize('auto')}>Auto</button>
          </div>
        </div>

        <div className="section" style={{ borderBottom: 'none' }}>
          <div className="section-label">How it works</div>
          <div style={{ fontSize: '11px', color: 'var(--text3)', lineHeight: 1.8 }}>
            1. Add products in Panel B<br/>
            2. Drop product images + model image per card<br/>
            3. Write prompt → Generate all<br/>
            4. Approve → auto-upscales 4× via Replicate<br/>
            5. Upscaled image cut into 4 quadrants
          </div>
        </div>

      </div>
    </div>
  );
};
